import { jwtDecode } from "jwt-decode";
import { StorageKey } from "../store/storage";
import { Role } from "../types/Role";
import store from "../store/store";

interface DecodedTokenIdentity {
    roles?: string[];
    [k: string]: unknown;
}

interface DecodedToken {
    roles?: string[];
    identity?: DecodedTokenIdentity | string;
    sub?: DecodedTokenIdentity | string;
    exp?: number;
    [k: string]: unknown;
}

export function getDecodedToken(): DecodedToken | null {
    const token = localStorage.getItem(StorageKey.TOKEN);
    if (!token) return null;
    try {
        return jwtDecode<DecodedToken>(token);
    } catch {
        return null;
    }
}

function rolesFromIdentity(value: DecodedTokenIdentity | string | undefined): string[] | null {
    if (!value) return null;
    if (typeof value === "object" && Array.isArray(value.roles)) return value.roles;
    if (typeof value === "string") {
        try {
            const parsed = JSON.parse(value);
            if (parsed && typeof parsed === "object" && Array.isArray(parsed.roles)) {
                return parsed.roles;
            }
        } catch {
            return null;
        }
    }
    return null;
}

function extractRolesFromJwt(decoded: DecodedToken | null): string[] {
    if (!decoded) return [];
    if (Array.isArray(decoded.roles)) return decoded.roles;
    return (
        rolesFromIdentity(decoded.identity) ??
        rolesFromIdentity(decoded.sub) ??
        []
    );
}

function getCurrentRoles(): string[] {
    const fromJwt = extractRolesFromJwt(getDecodedToken());
    if (fromJwt.length > 0) return fromJwt;
    return store.getState().user.userData?.roles ?? [];
}

export function isVisitor(): boolean {
    return getCurrentRoles().includes(Role.Visitor);
}
